import { Component, OnInit } from "@angular/core";
import { BpgCommonService } from "../../bpg-common/services/bpg-common.service";
import { BpgEventsService } from "../../bpg-events/bpg-events.service";
import { HoshinBudgetService } from "../hoshin-budget.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ConstantValues } from "../../bpg-common/models/bpg-constants";

import { EnvironmentConfiguration } from "src/app/environment/services/environment.configuration";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  Hoshin,
  Budget,
  Amount,
} from "../../bpg-common/services/data.services";

type unionType = Budget & Hoshin & Amount;
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: "app-hoshin-home",
  templateUrl: "./hoshin-home.component.html",
  styleUrls: ["./hoshin-home.component.css"],
})
export class HoshinHomeComponent implements OnInit {
  landingData: any;
  searchKey: any;
  budgetList: any[] = [];
  chapterList: any;
  tableShow: boolean;
  loginData: any = JSON.parse(localStorage.getItem("loginData"));
  userAndRoleIdDTO: any;
  userId: any = this.loginData.userId;
  adminId: any = localStorage.getItem("adminId");
  bpgId: any;
  siteId: any;
  status: any;
  chapterId = "";
  chapterIds: any[] = [];
  viewButton: boolean;
  completeButton: boolean;
  noDataFound: boolean;
  today = new Date();
  numberOfElements: number;
  currentPage = 0;
  limit: number = ConstantValues.pageLimit;
  totalPages = 0;
  currentShowingElements: number = ConstantValues.pageLimit;
  statusList: any;
  siteData: any;
  siteList: any;
  allSiteIds: any;
  selectedBpgId: any;
  selectedSiteId: any;
  selectedBpgsData: any;
  bpgList: any;
  allBpgIds: any;
  bpgValue: any;

  alertDeleteSuccess: boolean;
  buttonType: any;
  previousButton: any;
  tableresp: boolean;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  isbpgAdmin = false;
  isbpgLeadAdmin = false;
  isNaacAdmin = false;
  chaptersData: any;
  selectAllConstant = 'Select All';
  selectedStatus: any;
  constructor(
    private readonly bpgCommonService: BpgCommonService,
    private readonly bpgEventsService: BpgEventsService,
    private readonly hoshinBudgetService: HoshinBudgetService,
    private readonly router: Router,
    private readonly spinnerService: Ng4LoadingSpinnerService,

    private readonly environment: EnvironmentConfiguration
  ) {}

  ngOnInit() {
    if (
      this.environment.envName === "dev" ||
      this.environment.envName === "qa" ||
      this.environment.envName === "prod"
    ) {
      if (
        localStorage.getItem("loginData") === null ||
        localStorage.getItem("loginData") === undefined
      ) {
        this.router.navigate(["/log-out"]);
      }
    }

    if (localStorage.getItem("logOutFlag") === "true") {
      this.router.navigate(["/log-out"]);
    }

    this.userAndRoleIdDTO = {
      userId: this.loginData["userId"],
      roleId: localStorage.getItem("adminId"),
    };
    this.spinnerService.show();
    if (localStorage.getItem("isbpgAdmin") === "true") {
      this.isbpgAdmin = true;
    }
    if (localStorage.getItem("isbpgLeadAdmin") === "true") {
      this.isbpgLeadAdmin = true;
    }
    if (localStorage.getItem("isNaacAdmin") === "true") {
      this.isNaacAdmin = true;
    }
    if (
      this.adminId !== "1" &&
      this.adminId !== "2" &&
      this.adminId !== "3" &&
      this.adminId !== "4" &&
      !this.isbpgAdmin &&
      !this.isbpgLeadAdmin &&
      !this.isNaacAdmin
    ) {
      this.router.navigate(["/site-home"]);
    }
   
    this.spinnerService.show();
    this.logUserAction();
    this.statusList = [{ status: this.selectAllConstant }, { status: "NEW" }, { status: "DRAFT" }, { status: "SUBMITTED" }, { status: "APPROVED" }, { status: "REJECTED" }];
    this.tableShow = false;
    this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(
      (data) => {
        this.chapterList = data;
        this.chapterList.map((i) => {
          i.siteName = `${i.siteName}-${i.bpgName}`;
          return i;
        });

        for (let i = 0; i < this.chapterList.length; i++) {
          if (i === this.chapterList.length - 1) {
            this.chapterId = this.chapterId + this.chapterList[i].chapterId;
          } else {
            this.chapterId =
              `${this.chapterId}${this.chapterList[i].chapterId},`;
          }
        }

        this.siteData = {
          filter: {
            chapterId: this.chapterId,
          },
          moduleId: 0,
          page: 0,
          presentRole: "",
          searchTerm: "",
          size: 0,
          sortDirection: "DESC",
          sortProperty: "fiscal_year",
          uid: "",
        };
        this.bpgCommonService.getSiteList(this.siteData).subscribe((data) => {
          this.siteList = data;
          //filter default site from sitelist
          this.siteList = this.siteList.filter(
            (site) => site.locationCode !== "DFLT"
          );
          this.siteList.unshift({
            siteId: 0,
            siteName: this.selectAllConstant,
            bpgName: "",
          });

          for (let i = 0; i < this.siteList.length; i++) {
            if (i === 0) {
              this.allSiteIds = this.siteList[i].siteId;
            } else {
              this.allSiteIds = `${this.allSiteIds}${this.siteList[i].siteId},`;
            }
          }
          this.siteChange(0);
        });
        this.chapterList.unshift({
          chapterId: this.chapterId,
          siteName: this.selectAllConstant,
          bpgName: "",
        });
        this.landingData = {
          filter: { chapterId: this.chapterId },
          moduleId: 0,
          page: 0,
          presentRole: "",
          searchTerm: "",
          size: ConstantValues.pageLimit,
          sortDirection: "DESC",
          sortProperty: null,
          uid: "",
        };
          this.spinnerService.show();
          this.landingData.sortProperty = 'site_id';
          this.getChaptersList();
      },
      (err) => {
        this.spinnerService.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );

    if (window.innerWidth < 767) {
      this.tableresp = true;
    } else {
      this.tableresp = false;
    }
  }

  logUserAction() {
    const data = {
      userId : this.userId,
      categoryDescription : "Hoshin Home"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }

  /** For getting all budget data
   * @class HoshinListingComponent
   * @method getBudgetList
   */
  public getChaptersList() {
    this.timeOutError = false;
    this.spinnerService.show();
    this.hoshinBudgetService.getHoshinChapterListing(this.landingData).subscribe(
      (data) => {
        this.tableShow = true;
        this.chaptersData = data.content;
        this.numberOfElements = data.totalElements;
        this.spinnerService.hide();
        if (this.chaptersData.length === 0) {
          this.tableShow = false;
          this.noDataFound = true;
        } else {
          this.tableShow = true;
          this.noDataFound = false;
          this.spinnerService.hide();
        }
      },
      (err) => {
        this.spinnerService.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
  }


  /** For filtering data by current page
   * @class HoshinListingComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.landingData.page = event - 1;
    this.currentPage = event;

    if (this.currentPage * this.limit < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if (this.currentPage * this.limit > this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getChaptersList();
  }


  /** For searching the table through keywords
   * @class HoshinListingComponent
   * @method searchChapter
   */
  searchChapter() {
    this.timeOutError = false;
    this.selectedSiteId = this.siteId;
    this.selectedBpgId = this.bpgId;

    this.selectedSiteId = this.selectedSiteId ? this.selectedSiteId : null;
    this.selectedBpgId = this.selectedBpgId ? this.selectedBpgId : null;
    if (this.selectedBpgId === 0 || this.selectedBpgId === null) {
      this.selectedBpgId = null;
    }
    if (this.selectedSiteId === 0 || this.selectedSiteId === null) {
      this.selectedSiteId = null;
    }

    this.landingData = {
      filter: {
        siteId: this.selectedSiteId,
        bpgId: this.selectedBpgId,
        userId: this.userId,
        adminId : this.adminId,
        hoshinStatus : this.selectedStatus==this.selectAllConstant?null:this.selectedStatus
      },
      moduleId: 0,
      page: 0,
      presentRole: "",
      searchTerm: "",
      size: ConstantValues.pageLimit,
      sortDirection: "DESC",
      sortProperty: "site_id",
      uid: "1",
    };
    this.hoshinBudgetService.getHoshinChapterListing(this.landingData).subscribe(
      (data) => {
        this.tableShow = true;
        this.chaptersData = data.content;
        this.numberOfElements = data.totalElements;
        this.currentShowingElements = ConstantValues.pageLimit;
        this.currentPage = 1;
        if (this.chaptersData.length === 0) {
          this.tableShow = false;
          this.noDataFound = true;
        } else {
          this.tableShow = true;
          this.noDataFound = false;
        }
      },
      (err) => {
        this.spinnerService.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
  }




  viewMoreHoshinDetails(data) {
    sessionStorage.setItem("bpgIdForHoshin", JSON.stringify(data.bpgId));
    sessionStorage.setItem("siteIdForHoshin", JSON.stringify(data.siteId));
    this.router.navigate(["/hoshin"]);
    }

  /** For site change from site list
   * @class ExpenseClaimListComponent
   * @method siteChange
   * @returns Promise
   */
  public siteChange(event) {
    this.bpgList = [];
    this.selectedBpgId = null;
    this.bpgValue = null;
    this.bpgId = null;

    if (event !== undefined) {
      this.selectedSiteId = event.siteId;
    } else {
      this.selectedSiteId = 0;
      this.selectedSiteId = null;
    }

    this.selectedBpgsData = {
      filter: {
        siteId: this.selectedSiteId,
        userId: this.userAndRoleIdDTO.userId,
        adminId: this.userAndRoleIdDTO.roleId,
      },
      moduleId: 0,
      page: 0,
      presentRole: "string",
      searchTerm: "string",
      size: 0,
      sortDirection: "ASC",
      sortProperty: "string",
      uid: "string",
    };
    this.bpgCommonService
      .getMyBPGsList(this.selectedBpgsData)
      .subscribe((data) => {
        this.bpgList = data;
        if (this.bpgList.length > 1) {
          this.bpgList.unshift({ bpgId: 0, bpgName: this.selectAllConstant });
        }
        for (let i = 0; i < this.bpgList.length; i++) {
          if (i === 0) {
            this.allBpgIds = this.bpgList[i].bpgId;
          } else {
            this.allBpgIds = `${this.allBpgIds}${this.bpgList[i].bpgId},`;
          }
        }
      });
  }

  /** For bpg change from bpg list
   * @class ExpenseClaimListComponent
   * @method bpgChange
   * @returns Promise
   */

  bpgChange(event) {
    if (event !== undefined) {
      this.selectedBpgId = event.bpgId;
    } else {
      this.selectedBpgId = null;
    }
  }

  changeStatus(event) {
    if (event !== undefined) {
      this.selectedStatus = event.status;
    } else {
      this.selectedStatus = null;
    }
  }

}
